import { OdinController, RadioGroup } from '@myosh/odin-components';
import { t } from 'i18next';
import { useEffect, useMemo, useState } from 'react';
import type { Control } from 'react-hook-form';

interface DataCategoriesProps {
  /**
   * Limits displayed data categories. Matches value field in showTopOptions.
   * Accepts string values like 'all', 'top5', 'top10', 'top30'.
   * Legacy data may contain numeric values which are coerced to strings at runtime.
   */
  showTop?: string | number;
  control: Control;
}

const DataCategoriesToShowConfiguration = ({ showTop, control }: DataCategoriesProps) => {
  const [showSelectedOptions, setSelectedOptions] = useState<{ position: number; text: string; value: string }>();

  // Normalize showTop to string to handle potential numeric values from legacy data or API mismatches
  const normalizedShowTop = showTop != null ? String(showTop) : undefined;

  const showTopOptions = useMemo(() => {
    return [
      {
        position: 1,
        text: t('all'),
        value: 'all',
      },
      {
        position: 2,
        text: t('top5'),
        value: 'top5',
      },
      {
        position: 3,
        text: t('top10'),
        value: 'top10',
      },
      {
        position: 4,
        text: t('top30'),
        value: 'top30',
      },
    ];
  }, []);

  useEffect(() => {
    const matchedOption = showTopOptions.find((el) => el.value === normalizedShowTop);
    setSelectedOptions(matchedOption);
  }, [normalizedShowTop, showTopOptions]);

  return (
    <div className="my-2 flex flex-col pt-2">
      <OdinController
        name="showTop"
        control={control}
        render={({ field: { onChange } }) => (
          <RadioGroup
            id="showTopOption"
            name="showTopOption"
            data={showTopOptions}
            label={t('dataCategoriesToShow')}
            value={showSelectedOptions}
            orientation="VERTICAL"
            textField="text"
            valueField="value"
            onChange={onChange}
          />
        )}
      />
    </div>
  );
};

export default DataCategoriesToShowConfiguration;
